import { useEffect } from "react";
import { Heart } from "lucide-react";
import { useWishlist } from "../../../stores/cart";
import { ProductCard } from "./ProductCard";
import { useStorefrontContext } from "./StorefrontContext";

export function WishlistPage() {
  const { store, slug, paths, go } = useStorefrontContext();
  const saved = useWishlist(slug);
  const products = store.products.filter((p) => saved.includes(p.id));

  useEffect(() => {
    document.title = `Wishlist · ${store.name}`;
  }, [store.name]);

  return (
    <section className="zs-page">
      <h1 className="zs-title">Wishlist</h1>
      {products.length === 0 ? (
        <div className="zs-empty">
          <Heart size={32} aria-hidden="true" />
          <p>Tap the heart on any product to save it here.</p>
          <button type="button" className="zs-btn" onClick={() => go(paths.shop)}>
            Browse the shop
          </button>
        </div>
      ) : (
        <div className="zs-grid">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      )}
    </section>
  );
}
